export class Freshchat {
  static EVENT_USER_RESTORE_ID_GENERATED: any
  init(config: any) {
    return null
  }
  setUser(user: any, error: any) {
    return null
  }
  setUserProperties(setUserProperties: any, error: any) {
    return null
  }
  identifyUser(userId: any, userRestoreId: any, error: any) {
    return null
  }
  addEventListener(EVENT_USER_RESTORE_ID_GENERATED: any, CallbackMethod: any) {
    return null
  }
  getUser(freshChatUser: any) {
    return null
  }
  showConversations() {
    return null
  }
  removeEventListeners(EVENT_USER_RESTORE_ID_GENERATED: any) {
    return null
  }
  resetUser() {
    return null
  }
}
export class FreshchatConfig {
  constructor(APP_ID: any, APP_KEY: any) {
    null
  }
  domain: any
  teamMemberInfoVisible: any
  cameraCaptureEnabled: any
  gallerySelectionEnabled: any
  responseExpectationEnabled: any
  showNotificationBanner: any
  notificationSoundEnabled: any
  themeName: any
  stringsBundle: any
}
export class FreshchatUser {
  firstName: any
  lastName: any
  phone: any
}

export default {
  Freshchat,
  FreshchatConfig,
  FreshchatUser,
}
